import Start from "./components/Start";
import Configurator from "./components/Configurator";
import { useGlobalContext } from "./contextProvider/ContextProvider";
import { useEffect } from "react";
import { getApiBase } from "./config/runtimeConfig";

function App({ wpId }) {
  const apiBase = getApiBase();
  const {
    start,
    configuratorId,
    setConfiguratorId,
    setConfiguratorTitle,
    setConfiguratorSubheadline,
    setConfiguratorDescription,
    setNavigationHeadline,
    setAgbs,
    setMinCalendar,
    setMaxCalendar,
    setVacation,
    setWorkingdays,
    setExclusionDates,
  } = useGlobalContext();

  useEffect(() => {
    //set wpId or default
    const configuratorId = wpId || 1;

    if (configuratorId) {
      setConfiguratorId(configuratorId);

      fetch(`${apiBase}/api/configurator/${configuratorId}`)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          setConfiguratorTitle(data.title);
          setConfiguratorSubheadline(data.subheadline);
          setConfiguratorDescription(data.description);
          setNavigationHeadline(data.navigationheadline);
          setAgbs(data.agbs);
          setMinCalendar(data.min_calendar);
          setMaxCalendar(data.max_calendar);
          setVacation(data.vacation);
          setWorkingdays(data.workingdays);
          setExclusionDates(data.ausschluss);
        })
        .catch((error) => console.error(error));
    }
  }, [
    apiBase,
    setAgbs,
    setConfiguratorDescription,
    setConfiguratorId,
    setConfiguratorSubheadline,
    setConfiguratorTitle,
    setExclusionDates,
    setMaxCalendar,
    setMinCalendar,
    setNavigationHeadline,
    setVacation,
    setWorkingdays,
    wpId,
  ]);

  return (
    <div className="App">
      {start && configuratorId ? <Configurator /> : <Start />}
    </div>
  );
}

export default App;
